import React, { Component } from 'react'

interface SaveCanvasProps {
    canvasRef: React.RefObject<HTMLCanvasElement | null>
    filename?: string
}

interface SaveCanvasState {
}

export class SaveCanvas extends Component<SaveCanvasProps, SaveCanvasState> {
    constructor(props: SaveCanvasProps) {
        super(props)
        this.saveCanvas=this.saveCanvas.bind(this)
    }
    
    saveCanvas(){
        let canvas = this.props.canvasRef.current;
        if (canvas === null) {
            alert("We can't find the image you're looking to save.");
            return;
        }
        let url = canvas.toDataURL("image/png");
        let link = document.createElement('a');
        link.download = this.props.filename || 'recipe.png';
        link.href = url;
        link.click();
      }
    render() {
        return (
            <button onClick={this.saveCanvas}>Download Challenge</button>
        )
    }
}

export default SaveCanvas
